'use strict';

export default class AlarmExternalCostsComponent {
	public restrict: any;
	public template: any;
	public scope: any;

  constructor() {
    this.restrict = 'E'
    this.template = require('./alarm.externalcosts.component.html'),
      this.scope = {
        alarm: '='
      }
  }
  controller() {
  }
}